import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Link2 } from 'lucide-react';
import { toast } from 'sonner';
import { apiError } from '../../lib/apiError';

const MeetingLinkEditor = ({ booking, disabled, onSaved }) => {
  const [link, setLink] = useState(booking.meeting_link || '');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await axios.patch(`${API}/bookings/${booking.id}/meeting-link`, { meeting_link: link });
      toast.success('Meeting link saved — teacher and students have been notified');
      onSaved();
    } catch (e) {
      toast.error(apiError(e, 'Could not save meeting link'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mt-3">
      <label className="text-sm font-medium text-slate-700 flex items-center gap-1.5 mb-1.5">
        <Link2 className="w-4 h-4 text-violet-600" /> Meeting link (visible to teacher & students)
      </label>
      <div className="flex gap-2">
        <Input
          placeholder="https://meet.google.com/..."
          value={link}
          disabled={disabled}
          onChange={(e) => setLink(e.target.value)}
          className="bg-white"
          data-testid={`meeting-link-input-${booking.id}`}
        />
        <Button
          onClick={save}
          disabled={disabled || saving || !link.trim() || link.trim() === (booking.meeting_link || '')}
          className="bg-violet-600 hover:bg-violet-700 text-white rounded-full"
          data-testid={`meeting-link-save-${booking.id}`}
        >
          {saving ? 'Saving...' : booking.meeting_link ? 'Update' : 'Save'}
        </Button>
      </div>
    </div>
  );
};

export default MeetingLinkEditor;
